import React, { useEffect } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Dialog, DialogContent, DialogTitle, DialogActions, Typography, Divider } from '@material-ui/core'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import PartiesInfoFormProperties from './PartiesInfoFormProperties'
import PartiesInfoMakeValidationSchema from './PartiesInfoMakeValidationSchema'

const {
  button: { CngButton }
} = components

function PartiesInfoDialog(props) {
  const { partiesInfo, isView, onAddPartiesInfo, onEditPartiesInfo, open, onClose, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.PartiesInfo.TITLE)
  const saveButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.SAVE_BUTTON)

  const validationSchema = PartiesInfoMakeValidationSchema(translate)

  const methods = useForm({
    defaultValues: PartiesInfoFormProperties.formikProps.initialValues,
    resolver: yupResolver(validationSchema)
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    if (open) {
      if (partiesInfo) {
        reset(partiesInfo)
      } else {
        reset(PartiesInfoFormProperties.formikProps.initialValues)
      }
    }
  }, [open, partiesInfo])

  function onSubmit(data) {
    if (partiesInfo) {
      onEditPartiesInfo(data)
    } else {
      onAddPartiesInfo(data)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h5"><strong>{title}</strong></Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <PartiesInfoFormProperties.Fields disabled={isView} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <CngButton color="secondary" onClick={onClose} size="medium">Cancel</CngButton>
        {!isView && (
          <CngButton color="primary" onClick={handleSubmit(onSubmit)} size="medium">
            {partiesInfo ? 'Update' : saveButton}
          </CngButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default PartiesInfoDialog
